<template>
  <v-card class="elevation-1 primary card-empty visitor-card mt-8">
    <v-list-item one-line class="pt-1">
      <v-list-item-content>
        <v-list-item-title class="subtitle-1 mb-1 white--text font-weight-bold d-flex align-center justify-space-between">
          <span>CASES CREATED, PAPER REGISTER (last 10)</span>
          <slot name="headerTableRight"></slot>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-card-text class="bg-white text-area" style="min-height: auto">
      <v-simple-table style="width: 100%">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">First Name</th>
              <th class="text-left">Last Name</th>
              <th class="text-left">Accomodation Address</th>
              <th class="text-left">Flight Number</th>
              <th class="text-left">Type</th>
              <th class="text-left">Print</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(subject, i) in storedVistorSubjects" :key="subject.name + '-' + i" :class="subject.patientCaseId">
              <td>{{ subject.firstName }}</td>
              <td>{{ subject.lastName }}</td>
              <td>{{ subject.accommodationAddress }}</td>
              <td>{{ subject.travelFlightNumber }}</td>
              <td>{{ subject.registrationType }}</td>
              <td>
                <v-btn @click="printCase(subject)" small outlined color="primary"><v-icon left>mdi-printer</v-icon>Print</v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
    <v-card-text style="background: white" v-if="storedVistorSubjects.length === 0">
      <v-alert class="text-center">No data</v-alert>
    </v-card-text>
    <PrintCase :formDataParent="formData" :patientCase="patientCase" :registrationType="registrationTypeCaseTable" :id="'printCaseTable'" />
  </v-card>
</template>

<script>
import PrintCase from '@/views/CreateCasePage/components/PrintCase.vue';

export default {
  props: ['storedVistorSubjects'],
  components: {
    PrintCase
  },
  data() {
    return {
      formData: null,
      patientCase: null,
      registrationType: null
    };
  },
  methods: {
    printCase(subject) {
      this.formData = subject;
      this.patientCase = subject.patientCaseId;
      this.registrationType = subject.registrationType ? subject.registrationType : 'TRAVELER';

      setTimeout(() => {
        this.$htmlToPaper('printCaseTable');
      }, 400);
    }
  }
};
</script>

<style>
</style>